import { selfAxios } from "../../../../../axios/selfAxios.js";
async function reqGetDictCacheMapByTypeToPost(params) {
  const {
    data: { data }
  } = await selfAxios.post("/mtdsbase/internal/dict/getDictCacheMapByTypeToPost", params);
  return data;
}
export { reqGetDictCacheMapByTypeToPost };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/mtdsbase/internal/dict/getDictCacheMapByTypeToPost/post.js